import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Bahçeşehir Koltuk Yıkama", path: "/basaksehir/bahcesehir-koltuk-yikama" },
  { label: "Bahçeşehir Yorgan Yıkama", path: "/basaksehir/bahcesehir-yorgan-yikama" },
  { label: "Başak Mahallesi Koltuk Yıkama", path: "/basaksehir/basak-koltuk-yikama" },
  { label: "Başak Mahallesi Perde Yıkama", path: "/basaksehir/basak-perde-yikama" },
  { label: "Kayabaşı Koltuk Yıkama", path: "/basaksehir/kayabasi-koltuk-yikama" },
  { label: "Kayabaşı Battaniye Yıkama", path: "/basaksehir/kayabasi-battaniye-yikama" },
  { label: "Ziya Gökalp Mahallesi Koltuk Yıkama", path: "/basaksehir/ziya-gokalp-koltuk-yikama" },
  { label: "Ziya Gökalp Yerinde Yıkama", path: "/basaksehir/ziya-gokalp-yerinde-yikama" },
  { label: "Altınşehir Koltuk Yıkama", path: "/basaksehir/altinsehir-koltuk-yikama" },
  { label: "Altınşehir Kuru Temizleme", path: "/basaksehir/altinsehir-kuru-temizleme" },
  { label: "Başakşehir Merkez Koltuk Yıkama", path: "/basaksehir/merkez-koltuk-yikama" }
];

const BasaksehirServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BAŞAKŞEHİR HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BasaksehirServiceArea;
